var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "footer_top" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "site_footer" }, [
          _c("div", { staticClass: "site_map" }),
          _vm._v(" "),
          _c("div", { staticClass: "site_box" }, [
            _c(
              "div",
              { staticClass: "foot_item foot_item1" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("router-link", { attrs: { to: { path: "/contact" } } }, [
                  _c("span", { staticClass: "btn" }, [_vm._v("联系我们")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "foot_item" }, [
              _c("h1", [_vm._v("产品中心")]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "p",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { path: "/productChip" } } },
                        [
                          _c("a", { attrs: { href: "#" } }, [
                            _vm._v("数字电视")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { path: "/resale" } } },
                        [
                          _c("a", { attrs: { href: "#" } }, [
                            _vm._v("智慧零售")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("router-link", { attrs: { to: { path: "/study" } } }, [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("智慧学习")])
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foot_item" }, [
              _c("h1", [_vm._v("合作案例")]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "p",
                    [
                      _c("router-link", { attrs: { to: { path: "/cases" } } }, [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("合作案例")])
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foot_item" }, [
              _c("h1", [_vm._v("新闻动态")]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "p",
                    [
                      _c("router-link", { attrs: { to: { path: "/news" } } }, [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("新闻动态")])
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foot_item" }, [
              _c("h1", [_vm._v("关于我们")]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("div", { staticClass: "left" }, [
                  _c("p", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goDetail(1)
                          }
                        }
                      },
                      [_vm._v("企业简介")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goDetail(2)
                          }
                        }
                      },
                      [_vm._v("发展历程")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goDetail(3)
                          }
                        }
                      },
                      [_vm._v("荣誉资质")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(3)
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer_bottom" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "last_item" }, [
          _c("p", { staticStyle: { display: "flex" } }, [
            _vm._v(
              "\n          Copyright 2003-" +
                _vm._s(_vm.input1) +
                " 上海高清数字科技产业有限公司\n          版权所有 \n          "
            ),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://beian.miit.gov.cn/#/Integrated/index"
                }
              },
              [_vm._v("沪ICP备05009806号-2")]
            ),
            _vm._v(" "),
            _vm._m(4)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("../../../static/img/fot_logo.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "phone" }, [
      _c("i", { staticClass: "iconfont icon-phone" }),
      _vm._v("+86 21 61871158\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "adress" }, [
      _c("i", { staticClass: "iconfont icon-ditu" }),
      _vm._v("上海浦东新区东三里桥路1018号B座8楼(上海数字产业园)\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "foot_item" }, [
      _c("h1", [_vm._v("关注我们")]),
      _vm._v(" "),
      _c("div", { staticClass: "qrcode" }, [
        _c("img", {
          attrs: { src: require("../../../static/img/qrcode.jpg"), alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { display: "inline-flex" },
        attrs: {
          target: "_blank",
          href:
            "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502006564"
        }
      },
      [
        _vm._v("\n              "),
        _c("img", {
          attrs: { src: require("../../../static/img/batb.png"), alt: "" }
        }),
        _vm._v("\n            沪公网安备31011502006564号")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e61b5e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e61b5e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comcomponents/Footer.vue
// module id = null
// module chunks = 